// @ts-strict-ignore
import {
  Component,
  AfterViewInit,
  OnInit,
  ElementRef,
  ApplicationRef,
  NgZone,
  OnDestroy,
  ViewChild
} from '@angular/core';
import { LMHtmlPageUtilService } from './lm-html-page-util.service';
import { Router, NavigationEnd, NavigationStart, ActivatedRoute, RouterStateSnapshot } from '@angular/router';
import { SaveRequired } from '@base/lm-base';
import { LMBaseComponent, LMDialogInfo, LMDialogType } from '@base/lm-base.component';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMFormManualRepService } from '@form/lm-form-manual-rep.service';
import { LMContextService } from '@services/lm-context.service';
import { LMComponentInfoService, LMLoggerService, LMModalOpenService, LMModalWrapperService } from '@services/index';
import { BehaviorSubject, lastValueFrom, Observable, SubscriptionLike as ISubscription } from 'rxjs';
import { LMUniqueIdService } from '@utils/index';
import { LMActionFormDialogService } from '@modal/index';
import { LMHtmlUrlDocService } from '@services/lm-html-url-doc.service';
import { LMAppComponentService } from '@utils/lm-app-component.service';
import { LMBannerHeaderComponentRef } from '../banner/lm-banner-header-component-ref.service';
import { LMComponentTrackerService } from '@services/lm-component-tracker.service';
import {HtmlUrlDocHost} from "@html/lm-html-url-doc-host";

@Component({
  selector: 'lm-htmlpage',
  standalone: false,
  template: `
    @if (url) {
      <lm-html-url-doc #LMHtmlUrlDoc
        [isHtmlFragment]="_isHtmlFragment"
        [url]="url"
        (titleChanged)="onTitleChanged($event)"
        (customButtonsSet)="onCustomButtonsSet($event)"
        (changeToolbarDisabledState)="onChangeToolbarDisabledState($event)"
        >
      </lm-html-url-doc>
    }`,
  providers: [ LMHtmlPageUtilService, LMFormManualRepService, LMHtmlUrlDocService, LMComponentTrackerService ]
})
export class LMHtmlPageComponent extends LMBaseComponent implements AfterViewInit, OnInit, OnDestroy, SaveRequired, HtmlUrlDocHost {
  @ViewChild('LMHtmlUrlDoc') htmlDocComponent; // : LMHtmlUrlDocComponent;

  private htmlPageCodeLoaded = false;
  public url;
  public _isHtmlFragment: false;
  public autoLoadUrl: string;
  private toolbarButtonEventSubscription: ISubscription;
  private dirtyCheckComplete = false;

  constructor(
    private elementRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private lmHtmlPageUtilService: LMHtmlPageUtilService,
    private lmHtmlUrlDocService: LMHtmlUrlDocService,
    private activatedRoute: ActivatedRoute,
    private lmLoggerService: LMLoggerService,
    private lmBannerHeaderCompRef: LMBannerHeaderComponentRef,
    private lmActionFormDialogService: LMActionFormDialogService,
    public lmContextService: LMContextService,
    private appRef: ApplicationRef,
    private currentComponent: LMRouteComponentService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected lmAppComponentService: LMAppComponentService,
    protected lmModalWrapperService: LMModalWrapperService,
    protected lmModalOpenService: LMModalOpenService
  )  {
    super(lmBusyIndicatorService, lmComponentInfoService, lmUniqueIdService, lmAppComponentService, lmModalWrapperService, lmModalOpenService);

    this.activatedRoute.queryParams.subscribe((params: any) => {
      console.log(params);

      if (params.autoLoadUrl) {
        this.autoLoadUrl = params.autoLoadUrl;
        this._isHtmlFragment = params.isHtmlFragment;
      }
    });
    //  This is added for now to get by an issue where the preceived loading of the component is delayed.
    //  The constructor is called but then a 4-10 second delay is seen before the ngOnInit is called.
    //  The issue was written up but the issue closed as no example was submitted and the problem was not
    //  seen by a large number of people. Current plan is to try to dup the issue in a small example and
    //  submit. A link to the issue Below
    //  https://github.com/angular/angular/issues/18816
    //  setTimeout(() => {
    //    this.zone.run(() => {
    //      // DETECT CHANGES
    //      this.lmLoggerService.time('LMHtmlPage.constructor > setTimeout > zone.run detectChanges()');
    //      this.changeDetectionRef.detectChanges();
    //      this.lmLoggerService.timeEndCheck('LMHtmlPage.constructor > setTimeout > zone.run detectChanges()', 200);
    //    });
    //  });

    const routerEventsSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // This is needed to trigger a repaint when a mingle link is pressed
        setTimeout(() => {
          appRef.tick();
        });
      } else if (event instanceof NavigationStart) {
        // safety to anable the toolbar when leaving the screen since we do not want tto maintain the state between screens.
        if (this.lmBannerHeaderCompRef && this.lmBannerHeaderCompRef.instance) {
          this.lmBannerHeaderCompRef.instance.lmToolbarComponent.setToolbarDisabled(false);
        }
      }
    });
  }

  ngOnInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (!this.htmlPageCodeLoaded) {
          this.loadHtmlSpec(event.url);
        }
      }
    });

    this.loadHtmlSpec(this.router.url);
    this.subscribeToBannerEvents();
  }

  ngAfterViewInit() {
    this.currentComponent.setRouteComponent(<Component>this);
    this.htmlPageCodeLoaded = true;

    if (this.lmBannerHeaderCompRef && this.lmBannerHeaderCompRef.instance) {
      this.lmBannerHeaderCompRef.instance.fullPageScroll = false;
    }

    setTimeout(() => {
      if (!this.lmBannerHeaderCompRef.instance) {
        return;
      }

      const webApp = this.route.snapshot.params['webApp'];
      const resourceId = this.route.snapshot.params['resourceId'];

      const homePageTitle: string = this.lmContextService.getContext().homePageTitle;
      const urlParams = new URLSearchParams(decodeURIComponent(window.location.search));
      const passedTitle = urlParams.get('passedTitle');


      if (webApp === resourceId && homePageTitle && homePageTitle.length > 0) {
        this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = homePageTitle;
      } else  if (passedTitle && passedTitle.length > 0) {
        this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = passedTitle;
      } else {
        this.lmBannerHeaderCompRef.instance.toolbarSectionTitle = '';
      }
    }, 1);

    if (this.lmContextService.isBannerInRoute() && !this.lmContextService.isApplicationMenuV3()) {
      this.connectAppMenuButtonTrigger();
    }
  }

  ngOnDestroy() {
    if (this.toolbarButtonEventSubscription) {
      this.toolbarButtonEventSubscription.unsubscribe();
    }
  }

  public onCustomButtonsSet(customButtons: any) {
    if (this.htmlDocComponent) {
      setTimeout(() => {
        NgZone.assertInAngularZone();
        this.buildToolbarButtons(customButtons);
      }, 1);
    }
  }

  checkSaveRequired(fromUnifiedMenu?: boolean) {
    return this.modalNavigationBlocked(fromUnifiedMenu);
  }

  public getHtmlUrlDocService(): LMHtmlUrlDocService {
    return this.lmHtmlUrlDocService;
  }

  public allowPageNavigation(nextState?: RouterStateSnapshot, fromUnifiedMenu?: boolean): Promise<boolean> {
    // Skip angular route guard dirty check if it was already done by the unified Portal menu.
    if (this.dirtyCheckComplete) {
      this.dirtyCheckComplete = false;
      return Promise.resolve(true);
    }

    const hasUnsavedChanges = this.checkSaveRequired(fromUnifiedMenu);

    if (!hasUnsavedChanges) {
      this.dirtyCheckComplete = true;
      this.closeModals();
      return Promise.resolve(true);
    }

    if (this.modalNavigationBlocked(fromUnifiedMenu)) {
      const youMayNavigateSource = new BehaviorSubject<boolean>(false);
      const youMayNavigate: Observable<boolean> = youMayNavigateSource.asObservable();
      // let's just ask if they want to stay,
      // difficult to determine the modal's purpose - it may run an action or it may just return unsaved data
      this.displayNavigationConfirmation().then((continueOn) => {
        if (continueOn) { // leave
          this.dirtyCheckComplete = true;
          this.closeModals();
        }
        youMayNavigateSource.next(continueOn);
        youMayNavigateSource.complete();
      });
      return lastValueFrom(youMayNavigate);
    } else {
      this.closeModals();
      return Promise.resolve(true);
    }
  }

  modalNavigationBlocked(fromUnifiedMenu?: boolean) {
    if (fromUnifiedMenu) {
      return this.modalOpen();
    } else {
      return this.lmActionFormDialogService.hasOpenDialog && this.lmActionFormDialogService.getOpenDialog?.componentDialog?.formComponent?.isModified();
    }
  }

  loadHtmlSpec(url: string) {
    if (this.autoLoadUrl) {
      this.url = this.autoLoadUrl;
    } else {
      this.url = this.lmHtmlPageUtilService.getHtmlPage(url);
    }
  }

  setHtmlPageSpec(spec: any) {

  }

  setHtmlPageCode(code: string) {
    this.elementRef.nativeElement.innerHTML = code;
  }

  loadHtmlPageCSSArray(urlArray) {
    for (let i = 0; i < urlArray.length; i++)  {
      this.loadHtmlPageCSS(urlArray[i]);
    }
  }

  loadHtmlPageCSS(url) {
    // Create link
    const link = document.createElement('link');
    link.href = url;
    link.rel = 'stylesheet';
    link.type = 'text/css';

    const head = document.getElementsByTagName('head')[0];
    const links = head.getElementsByTagName('link');
    const style = head.getElementsByTagName('style')[0];

    // Check if the same style sheet has been loaded already.
    let isLoaded = false;
    for (let i = 0; i < links.length; i++) {
      const node = links[i];
      if (node.href.indexOf(link.href) > -1) {
        isLoaded = true;
      }
    }
    if (isLoaded) {
      return;
    }

    head.insertBefore(link, style);
  }

  loadHtmlPageJSArray(urlArray): Promise<LMHtmlPageComponent> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self: LMHtmlPageComponent  = this;
    return new Promise(function(resolve, rejectPromise) {
      const promiseArray = [];

      for (let i = 0; i < urlArray.length; i++) {
        promiseArray.push(
          // todo: use an observable instead.
          new Promise(function(resolve2, rejectPromise2) {
            const scr = document.createElement('script');
            scr.type = 'text/javascript';
            scr.src = urlArray[i] + '?ts=' + new Date().getTime();
            document.getElementsByTagName('head')[0].appendChild(scr);
            setTimeout(function() {
              resolve2(true);
            }, 100);
          })

        );
      }
      Promise.all(promiseArray).then(function(results) {
        resolve(self);
      });
    });
  }

  loadHtmlPageJS(url): Promise<boolean> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    const promise = new Promise<boolean>((resolve: Function, reject: Function) => {
      const scr = document.createElement('script');
      scr.type = 'text/javascript';
      scr.src = url + '?ts=' + new Date().getTime();
      document.getElementsByTagName('head')[0].appendChild(scr);
      setTimeout(() => resolve(true), 100);
    });

    promise.catch(e => this.lmLoggerService.log('fail JS load' + e.getStacktrace()));

    return promise;
  }

  setHtmlPageCss(code: string) {
    const style = document.createElement('style');
    style.innerHTML = code;
    document.head.appendChild(style);
  }
  setHtmlPageJs(code: string): boolean {
    const script = document.createElement('script');
    script.innerHTML = code;
    setTimeout(function() {
      document.head.appendChild(script);
    }, 1);
    return true;
  }

  public buildToolbarButtons(toolbarButtons: Array<LMToolbarButton> ) {
    this.lmBannerHeaderCompRef.instance.lmToolbarComponent.forceUpdate();
    this.lmBannerHeaderCompRef.instance.lmToolbarComponent.buttons = toolbarButtons;
  }

  private subscribeToBannerEvents() {
    this.toolbarButtonEventSubscription = this.lmBannerHeaderCompRef?.instance?.toolbarButtonEvent.subscribe((toolbarButtonEvent: LMToolbarButtonEvent) => {
      this.onToolbarButtonEvent(toolbarButtonEvent);
    });
  }

  public onToolbarButtonEvent(toolbarButtonEvent: LMToolbarButtonEvent): void {
    if (this.htmlDocComponent) {
      this.htmlDocComponent.fireCustomButtonPressed(toolbarButtonEvent.customToolbarButtonInfo);
    }
  }

  public onTitleChanged(event: any) {
    if (this.lmBannerHeaderCompRef.instance) {
      const titleChanged = event.detail;
      this.lmBannerHeaderCompRef.instance.toolbarSectionTitle =
        (this.url.indexOf('/land/') >= 0) ? '' : titleChanged.newTitle;
    }
  }

  public onChangeToolbarDisabledState(event: any) {
    if (this.lmBannerHeaderCompRef.instance) {
      this.lmBannerHeaderCompRef.instance.lmToolbarComponent.setToolbarDisabled(event);
    }
  }

  public getUserWebRequestId(): string {
    return 'LMHtmlPage' + '-' +this.getBaseCompId();
  }

  public getComponentInfo(additionalInfo?: LMCompInfoAdditionalInfo): LMComponentInfo {
    // let compiledTemplate = urltemplate.parse(this.pageSpec);
    // let loadUrl = compiledTemplate.expand({ resourceId: this.model.getData().resourceId });

    const formInfo: LMComponentInfo = {
      componentType: 'HTMLPage',
      name: 'HTMLPage',
      type: 'page',
      developer: false,
      isWizard: false,
      panelNavigation: false,
      hasConfigAccess: this.lmContextService.hasConfigAccess(),
      // loadUrl: '',
      // dataUrl: '',
      // specUrl: '',
    };

    return formInfo;
  }

  public getComponentPlaceHolder() {
    return this.placeHolder;
  }

  saveComponentState(includeSubComponents?: boolean): void {
  }
}
